import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ServiceInfoClientService } from '../../files-clients/service/service-info-client.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-modal-update-invoces',
  templateUrl: './modal-update-invoces.component.html',
  styleUrls: ['./modal-update-invoces.component.scss']
})
export class ModalUpdateInvocesComponent {
  public meses = [1,3,6,12,18,24,30,36];
  public formMeses: FormGroup;
  public mes = 1
  
  constructor( private fb: FormBuilder, private serviceInfo: ServiceInfoClientService, @Inject(MAT_DIALOG_DATA) public rutUrl: number, public dialogRef: MatDialogRef<ModalUpdateInvocesComponent> ) {
    this.formMeses = this.fb.group({
      meses: [1, [Validators.required]],
    });
  }

  ngOnInit() {

  }

  public formatLabel(value: number): string {
    if (value >= 1000) {
      return Math.round(value / 1000) + 'k';
    }

    this.mes = value;
    return `${value}`;
  }

  public updateInvoceCompany() {
    var meses = this.mes;
    Swal.fire({
      title: 'Actualizando',
      text: 'Actualizando información',
      didOpen: () => {
        Swal.showLoading();
      },
    });
    this.dialogRef.close();
    this.serviceInfo.updateInvocesCompany(meses, this.rutUrl)
    .subscribe({
      next: (res) => {
        Swal.fire({
          title: 'Listo',
          text: 'Se ha actualizado la información',
          icon: 'success',
        }).then((result) => {
          window.location.reload();
        });
        // this.dialogRef.close();
      },
      error: (err) => {
        Swal.fire({
          icon: 'error',
          text: err.error.resultMessage
        });
      }
    })
  }

}
